import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { NavbarDashbord } from './navbarDashbord';
import { Wind, FolderKanban, Users, ShoppingCart, TrendingUp, CheckCircle, Clock, PlusCircle, LayoutGrid, MessageSquare } from 'lucide-react';
import '../styles/admin.css';

export function DashbordPage() {
    const state = useSelector(state => state) || {};
    const listC = state.listC || [];
    const listP = state.listP || [];
    const comptes = state.comptes || [];
    const commandes = state.commandes || [];

    const stats = [
        { label: 'Climatiseurs', value: listC.length.toString(), icon: <Wind size={24} />, color: '#000033' },
        { label: 'Projets', value: listP.length.toString(), icon: <FolderKanban size={24} />, color: '#700000' },
        { label: 'Comptes Actifs', value: comptes.filter(c => c.status === 'Actif').length.toString(), icon: <Users size={24} />, color: '#2e7d32' },
        { label: 'Commandes Totales', value: commandes.length.toString(), icon: <ShoppingCart size={24} />, color: '#f59e0b' },
    ];

    const orderStats = [
        { label: 'Livrées', value: commandes.filter(c => c.statut?.toLowerCase() === 'livrée').length.toString(), icon: <CheckCircle size={20} />, color: 'var(--admin-success)', link: '/pageCommandes?status=livrée' },
        { label: 'En cours', value: commandes.filter(c => c.statut?.toLowerCase() === 'en cours').length.toString(), icon: <TrendingUp size={20} />, color: 'var(--admin-warning)', link: '/pageCommandes?status=en%20cours' },
        { label: 'En attente', value: commandes.filter(c => c.statut?.toLowerCase() === 'en attente').length.toString(), icon: <Clock size={20} />, color: 'var(--admin-danger)', link: '/pageCommandes?status=en%20attente' },
    ];

    const activityData = [
        { label: 'Visites', value: 85, color: '#000033' },
        { label: 'Commandes', value: (commandes.length * 10), color: '#700000' },
        { label: 'Avis (+)', value: (listC.reduce((acc, c) => acc + (c.commantaires ? c.commantaires.length : 0), 0) * 5) || 20, color: '#2e7d32' },
        { label: 'Projets', value: (listP.length * 8), color: '#f59e0b' },
        { label: 'Livrées', value: (commandes.filter(c => c.statut?.toLowerCase() === 'livrée').length * 15), color: '#10b981' },
    ];

    return (
        <div className="admin-layout">
            <NavbarDashbord />
            <main className="admin-main-content">
                <header className="admin-header">
                    <div className="admin-title-group">
                        <h1>Command Center</h1>
                        <p>Pilotage intelligent de Jamas Lens.</p>
                    </div>
                </header>

                {/* Top Row: Stats + Actions */}
                <div className="dashboard-top-row">
                    <div className="dashboard-stats-grid-mini">
                        {stats.map((stat, idx) => (
                            <div key={idx} className="dashboard-mini-card">
                                <div className="mini-card-icon" style={{ backgroundColor: `${stat.color}10`, color: stat.color }}>
                                    {stat.icon}
                                </div>
                                <div className="mini-card-info">
                                    <span className="mini-card-value">{stat.value}</span>
                                    <span className="mini-card-label">{stat.label}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    <div className="dashboard-quick-actions">
                        <Link to="/admin-climatisseur/add" className="quick-action-btn primary">
                            <PlusCircle size={18} />
                            <span>Nouveau Climatiseur</span>
                        </Link>
                        <Link to="/admin-projet/add" className="quick-action-btn secondary">
                            <LayoutGrid size={18} />
                            <span>Nouveau Projet</span>
                        </Link>
                        <Link to="/pageCommentaires" className="quick-action-btn accent">
                            <MessageSquare size={18} />
                            <span>Nouveau Commentaire</span>
                        </Link>
                    </div>
                </div>

                <div className="dashboard-grid-secondary">
                    <div className="admin-chart-section">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                            <h2 style={{ fontSize: '1.1rem', color: 'var(--admin-primary)', fontWeight: '800', margin: 0 }}>Analyse d'Activité</h2>
                            <span style={{ fontSize: '0.65rem', color: 'var(--admin-success)', fontWeight: '700', backgroundColor: 'rgba(16, 185, 129, 0.1)', padding: '4px 10px', borderRadius: '20px' }}>Sync Dynamique</span>
                        </div>
                        <div className="chart-wrapper">
                            {activityData.map((data, i) => (
                                <div key={i} className="bar-container">
                                    <div 
                                        className="bar" 
                                        style={{ 
                                            height: `${data.value}%`,
                                            background: `linear-gradient(to top, ${data.color}, ${data.color}99)`,
                                            width: '60%',
                                            borderRadius: '4px 4px 0 0'
                                        }}
                                        title={`${data.value}% ${data.label}`}
                                    ></div>
                                    <span style={{ fontSize: '0.6rem', fontWeight: '800', color: 'var(--admin-text-muted)', marginTop: '8px', whiteSpace: 'nowrap' }}>{data.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="admin-status-box">
                        <h2 style={{ fontSize: '1.1rem', color: 'var(--admin-primary)', fontWeight: '800', marginBottom: '20px' }}>Flux des Commandes</h2>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {orderStats.map((item, idx) => (
                                <Link 
                                    to={item.link} 
                                    key={idx} 
                                    className="status-row-item"
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div className="status-icon-box" style={{ backgroundColor: `${item.color}10`, color: item.color }}>
                                            {item.icon}
                                        </div>
                                        <div>
                                            <p style={{ margin: 0, fontWeight: '700', fontSize: '0.8rem' }}>{item.label}</p>
                                            <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--admin-text-muted)' }}>Mise à jour en direct</p>
                                        </div>
                                    </div>
                                    <span style={{ fontWeight: '900', fontSize: '1.1rem', color: 'var(--admin-primary)' }}>{item.value}</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="activity-feed-section">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2 style={{ fontSize: '1.1rem', color: 'var(--admin-primary)', fontWeight: '800', margin: 0 }}>Activités Récentes</h2>
                        <Link to="/pageHistorique" style={{ textDecoration: 'none', color: 'var(--admin-secondary)', fontWeight: '700', fontSize: '0.75rem', cursor: 'pointer' }}>Historique du jour</Link>
                    </div>
                    <div className="feed-list">
                        <div className="feed-item">
                            <div className="feed-indicator success"></div>
                            <div className="feed-content">
                                <p className="feed-title">Nouvelle commande confirmée</p>
                                <p className="feed-subtitle">Aujourd'hui à 14:30 par Yassine Karim</p>
                            </div>
                            <div className="feed-meta">
                                <span className="feed-amount">+8,400 MAD</span>
                                <Link to="/pageCommandes" className="feed-link">Détails</Link>
                            </div>
                        </div>
                        <div className="feed-item">
                            <div className="feed-indicator warning"></div>
                            <div className="feed-content">
                                <p className="feed-title">Avis reçu sur LG AC09BK</p>
                                <p className="feed-subtitle">Aujourd'hui à 11:15 • mndrissi@gmail.com</p>
                            </div>
                            <div className="feed-meta">
                                <Link to="/admin-climatisseur/edit/1" className="feed-link">Gérer l'avis</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}